import { useSelector } from 'react-redux';
import { RootState } from '../../Store';
import { Period } from '../../Interface/Interest/Period';
import { PeriodState } from '../../Store/Period/state';

const useGetPeriods = (): Period[] => {
    const { periods } = useSelector<RootState, PeriodState>(state => state.period);

    return periods;
}

export default useGetPeriods;
